var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('default-heading',{staticClass:"mt-3"},[_vm._v("Reports")]),_c('div',{staticClass:"my-4"}),_c('b-alert',{attrs:{"show":""}},[_vm._v("Currently no reports.")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }